import { getCountry } from '../../iwIntlProvider/CountryProvider';

export const required = (value) =>
    value ? undefined : 'This field is required';

export const validatePostcode = (validationErrorMessage, value) => {
    switch (getCountry()) {
        case 'UK':
            if (!value) return validationErrorMessage;
            break;
        case 'DE':
            if (!value || value.length !== 5) return validationErrorMessage;
            break;
    }

    return undefined;
};
